import { type AttachmentResponseDto } from '@issuemanager/api-client';
import { Stack } from '@mui/material';
import React from 'react';
import { GroupedDocumentList } from '../../issue/components/grouped-document-list';
import { useGroupedAttachments } from '../../issue/hooks/use-grouped-attachments';

type Props = {
  attachments: AttachmentResponseDto[];
};

export function ReadonlyDocuments({ attachments }: Props): React.JSX.Element {
  const { regularAttachments, approvalAttachments } =
    useGroupedAttachments(attachments);

  return (
    <Stack data-testid='documents' spacing={4}>
      <GroupedDocumentList
        regularAttachments={regularAttachments}
        approvalAttachments={approvalAttachments}
      />
    </Stack>
  );
}
